import { Injectable } from '@angular/core';
import { RouteDetail } from '@app/pages/routes/models/route-detail';
import  moment from 'moment';
import { Api } from './api.service';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { RouteDeliveryModel, RouteModel } from '@app/shared/models/route-allocation.model';

@Injectable()
export class RouteService extends BaseService {
  controllerName = 'api/route';

  constructor(protected api: Api) {
    // put controller url for BaseService
    super(api, 'api/Route');
  }

  public getRoutes() {
    return this.api.get(`${this.controllerName}/get-routes`);
  }


  getRouteDetail(id: number, startDate: string, endDate: string) {
    const params: any = {
      startDate: moment(startDate).format('L'), // MM/dd/yyyy
      endDate: moment(endDate).format('L'), // MM/dd/yyyy
    };
    return this.api.get(`${this.controllerName}/${id}`, params);
  }

  exportPdf(route: RouteDetail) {
    return this.api.post(`${this.controllerName}/exportpdf`, route);
  }

  isCustomerAllocatedToRoute(customerId: number, date: moment.Moment) {
    const params: any = { date: date.format('L') };
    return this.api.get(`${this.apiUrl}/is-customer-allocated-to-route/${customerId}`, params);
  }

  getRouteAllocations(startDate: moment.Moment, endDate: moment.Moment, vehicleIds: number[], routeIds: number[]): Observable<RouteModel[]> {
    const params: any = {
      startDate: moment(startDate).format('L'), // MM/dd/yyyy
      endDate: moment(endDate).format('L'), // MM/dd/yyyy
      vehicleIds: vehicleIds,
      routeIds: routeIds
    };
    return this.api.get(`${this.controllerName}/get-route-allocation`, params);
  }

}
